import type { RootModel } from '.';
import { createModel } from "@rematch/core";

import { SystemUserTypes } from '../types';

export interface AuthStoreProps {
    user: SystemUserTypes.Model,
    authUser: SystemUserTypes.Model,
    token: string,
    loading: {
        login: boolean,
    },
};
export const auth = createModel<RootModel>()({
    state: {
        user: {} as SystemUserTypes.Model,
        authUser: {} as SystemUserTypes.Model,
        firstLogin: false,
        token: '',
        loading: {
            login: false,
        },
    },
    reducers: {
        toggleLoading: (
            store, prop: keyof AuthStoreProps['loading'], v: boolean) => {
                store.loading[prop] = v;
            },
        logout: (store) => {    
            store.authUser = {} as SystemUserTypes.Model;
            store.token = '';
        },
        setFirstLogin: (store, v: boolean) => {
            store.authUser.isFirstLogin = v;
        },
        auth: 
            (store, user: SystemUserTypes.Model, token: string) => {
                store.authUser = user;
                store.token = token;
            },
        updateUser:
            (store, user: SystemUserTypes.Model) => {
                store.authUser = user;
            },
    },
});
